import React from 'react';
import { Text, View } from 'react-native';
import { CalendarList } from 'react-native-calendars';
import moment from 'moment';
import i18n from 'i18n-js';

import { scale, width } from '@components/frame';
import { font } from '@styles/fonts';
import { isWeb } from '@helpers';
import TouchableElement from '@components/common/touchableElement';

const RANGE = 24;

const CalendarListScreen = ({ C, selectedChartDate, setSelectedChartDate, hide }) => {
  const onDayPress = (day) => {
    setSelectedChartDate(moment.utc(day.dateString).format());
    hide();
  };

  const renderCustomHeader = (date) => {
    const header = date.toString('MMM yyyy');
    const [month, year] = header.split(' ');
    const textStyle = {
      fontSize: 18,
      paddingTop: 10,
      paddingBottom: 10,
      color: 'rgb(45, 65, 80)',
      paddingRight: 5,
    };

    return (
      <View
        style={{
          flexDirection: 'row',
          width: '100%',
          justifyContent: 'space-between',
          marginTop: 10,
          marginBottom: 10,
        }}
      >
        <Text style={[{ marginLeft: 5 }, textStyle]}>{`${month}`}</Text>
        <Text style={[{ marginRight: 5 }, textStyle]}>{year}</Text>
      </View>
    );
  };

  const theme = {
    stylesheet: {
      calendar: {
        header: {
          dayHeader: {
            fontWeight: '600',
            color: '#48BFE3',
          },
        },
      },
    },
    'stylesheet.day.basic': {
      today: {
        backgroundColor: C('Button/Light/Primary'),
        borderRadius: 17,
      },
      todayText: {
        color: C('Label/Light/AlwaysLight Primary'),
      },
    },
  };

  const current = moment(selectedChartDate).format('YYYY-MM-DD') || moment().format('YYYY-MM-DD');
  const futureScrollRange = moment().endOf('month').diff(moment(current), 'month');

  return (
    <View style={[isWeb && { flex: 1 }, { paddingTop: scale(58) }]}>
      <View
        style={{
          width: '100%',
          zIndex: 1000,
          height: scale(58),
          position: 'absolute',
        }}
      >
        <View style={{ position: 'absolute', zIndex: 1000, left: 0 }}>
          <TouchableElement
            onPress={() => {
              setSelectedChartDate(moment.utc().format());
              hide();
            }}
          >
            {({ boxStyle, pressHoverColor }) => (
              <View style={[boxStyle, { padding: scale(15) }]}>
                <Text style={[{ color: C(pressHoverColor('Link/Light/Primary')) }, font.Headline]}>{i18n.t('Today')}</Text>
              </View>
            )}
          </TouchableElement>
        </View>
        <View style={{ position: 'absolute', zIndex: 1000, right: 0 }}>
          <TouchableElement
            onPress={() => {
              hide();
            }}
          >
            {({ boxStyle, pressHoverColor }) => (
              <View style={[boxStyle, { padding: scale(15) }]}>
                <Text style={[{ color: C(pressHoverColor('Link/Light/Primary')) }, font.Headline]}>{i18n.t('Done')}</Text>
              </View>
            )}
          </TouchableElement>
        </View>
        <View style={{ width: '100%', position: 'absolute', zIndex: 100, top: scale(15) }}>
          <Text style={[{ color: C('Label/Light/Primary'), width: '100%', textAlign: 'center' }, font.Headline]}>{i18n.t('Calendar')}</Text>
        </View>
      </View>
      <CalendarList
        testID={'calendarList'}
        current={current}
        pastScrollRange={RANGE}
        futureScrollRange={futureScrollRange}
        onDayPress={onDayPress}
        // markedDates={marked}
        renderHeader={renderCustomHeader}
        calendarHeight={scale(200)}
        calendarWidth={Math.min(width, scale(480))}
        theme={theme}
        horizontal={false}
        pagingEnabled={false}
        staticHeader={false}
      />
    </View>
  );
};

export default CalendarListScreen;
